import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { CampaignMissing } from 'ui/illustrations';
import noop from 'utils/noop';
import { ErrorStateContainer, ErrorStateTitle, ErrorSubTitle } from './Styled';

type ErrorStateProps = {
  handleReload?: () => void;
};

export const Error = ({ handleReload = noop }: ErrorStateProps) => {
  const { t } = useGoalsTranslations();

  return (
    <ErrorStateContainer>
      <CampaignMissing />
      <ErrorStateTitle>{t('errorState.title')}</ErrorStateTitle>
      <ErrorSubTitle onClick={handleReload}>{t('errorState.subTitle')}</ErrorSubTitle>
    </ErrorStateContainer>
  );
};
